import { TableData } from "./table";

export const EVENT_TYPE_DELIVERED = "DELIVERED";
export const EVENT_TYPE_CONSUMED = "CONSUMED";
export const EVENT_TYPE_WITHDRAWN = "WITHDRAWN";
export const EVENT_TYPE_ADDED = "ADDED";
export const EVENT_TYPE_DELETED = "DELETED";
export const EVENT_TYPE_RESERVED = "RESERVED";
export const EVENT_TYPE_UNRESERVED = "UNRESERVED";
export const EVENT_TYPE_BUNDLE_UPDATE = "BUNDLE_UPDATE";
export const EVENT_TYPE_RATE_CARD_UPDATE = "RATE_CARD_UPDATE";

export const EVENTS = [
    EVENT_TYPE_CONSUMED,
    EVENT_TYPE_DELIVERED,
    EVENT_TYPE_WITHDRAWN,
    EVENT_TYPE_ADDED,
    EVENT_TYPE_DELETED,
    EVENT_TYPE_RESERVED,
    EVENT_TYPE_UNRESERVED,
    EVENT_TYPE_BUNDLE_UPDATE,
    EVENT_TYPE_RATE_CARD_UPDATE,
];
export type EventType = (typeof EVENTS)[number];

export enum EventActions {
    ENTITLEMENT_CREATION = "ENTITLEMENT_CREATION",
    FEATURE_LICENSE_CONSUMPTION = "FEATURE_LICENSE_CONSUMPTION",
    LICENSE_CONSUMPTION = "LICENSE_CONSUMPTION",
    LICENSE_DELIVERY = "LICENSE_DELIVERY",
    LICENSE_DELIVERY_ASSIGNED = "LICENSE_DELIVERY_ASSIGNED",
    LICENSE_DELIVERY_RECEIVED = "LICENSE_DELIVERY_RECEIVED",
    LICENSE_KEY_CONSUMPTION = "LICENSE_KEY_CONSUMPTION",
    LICENSE_KEY_CREATION = "LICENSE_KEY_CREATION",
    LICENSE_KEY_DELETION = "LICENSE_KEY_DELETION",
    LICENSE_RESTORATION = "LICENSE_RESTORATION",
    SECURE_LICENSE_CONSUMPTION = "SECURE_LICENSE_CONSUMPTION",
    TENANT_DELETION = "TENANT_DELETION",
    LICENSE_POOL_UPDATE = "LICENSE_POOL_UPDATE",
    LICENSING_MODEL_CHANGE = "LICENSING_MODEL_CHANGE",
    CONTRACT_TYPE_CHANGED = "CONTRACT_TYPE_CHANGED",
    LICENSE_KEY_UPDATE = "LICENSE_KEY_UPDATE",
    REGISTER = "REGISTER",
    BUNDLE_CHANGE = "BUNDLE_CHANGE",
    RATE_CARD_CHANGE = "RATE_CARD_CHANGE",
    UNREGISTER = "UNREGISTER",
    UNRECOGNISED = "UNRECOGNISED",
}

export enum SOURCE_EVENTS {
    BMP = "BMP",
    ON_PREMISE = "ON_PREMISE",
}

export const EVENT_ACTIONS: string[] = [
    EventActions.ENTITLEMENT_CREATION,
    EventActions.FEATURE_LICENSE_CONSUMPTION,
    EventActions.LICENSE_CONSUMPTION,
    EventActions.LICENSE_DELIVERY,
    EventActions.LICENSE_DELIVERY_ASSIGNED,
    EventActions.LICENSE_DELIVERY_RECEIVED,
    EventActions.LICENSE_KEY_CONSUMPTION,
    EventActions.LICENSE_RESTORATION,
    EventActions.LICENSE_KEY_CREATION,
    EventActions.LICENSE_KEY_DELETION,
    EventActions.TENANT_DELETION,
    EventActions.LICENSE_POOL_UPDATE,
    EventActions.LICENSING_MODEL_CHANGE,
    EventActions.CONTRACT_TYPE_CHANGED,
    EventActions.LICENSE_KEY_UPDATE,
    EventActions.REGISTER,
    EventActions.BUNDLE_CHANGE,
    EventActions.RATE_CARD_CHANGE,
    EventActions.UNREGISTER,
    EventActions.UNRECOGNISED,
];
export type EventAction = (typeof EVENT_ACTIONS)[number];

export interface LicenseEvent {
    eventUuid: string;
    eventDate: string;
    productId: string;
    eventType: EventType;
    change: number;
    remaining: number;
    expirationDate: string;
    user: string;
    poolName: string;
    eventAction: EventAction;
    notes?: string;
    licenseConsumptionId?: string;
    assetId?: string;
    targetedTenant?: string;
    amountBefore?: number;
    amountAfter?: number;
    usedAmount?: number;
    eventSource?: string;
    productName?: string;
    productVersion?: string;
    extra?: string;
    assignmentMode?: string;
}

export interface LicenseEventQuery {
    search: string;
    from: string;
    to: string;
    productIds: string[];
    actions: string[];
    eventActions: string[];
    eventSources: string[];
    cursor?: KeyCursor;
}

export interface KeyCursor {
    eventUuid: string;
    tenantUuid: string;
    time: string;
}

export interface LicenseEventResult extends TableData {
    licenseEvents: LicenseEvent[];
    cursor?: KeyCursor;
}

export interface TableState {
    licenseEvents: LicenseEvent[];
    cursor?: KeyCursor;
    scrollPosition: number;
}

export interface FilterState {
    startDate: string;
    endDate: string;
    eventTypes: EventType[];
    quickSearchFilter: string;
    productIds: string[];
    actions: string[];
    eventSources: string[];
}

export const DELIVERY_ACTIONS: string[] = [
    EventActions.LICENSE_DELIVERY,
    EventActions.LICENSE_KEY_CREATION,
    EventActions.ENTITLEMENT_CREATION,
    EventActions.LICENSE_DELIVERY_RECEIVED,
    EventActions.LICENSE_DELIVERY_ASSIGNED,
    EventActions.LICENSE_KEY_UPDATE,
];

export const WITHDRAWN_ACTIONS: string[] = [
    EventActions.TENANT_DELETION,
    EventActions.LICENSE_POOL_UPDATE,
    EventActions.LICENSE_RESTORATION,
];

export const CONSUMPTION_ACTIONS: string[] = [
    EventActions.FEATURE_LICENSE_CONSUMPTION,
    EventActions.LICENSE_CONSUMPTION,
    EventActions.LICENSE_KEY_CONSUMPTION,
];

export const DELETE_ACTIONS: string[] = [
    EventActions.LICENSING_MODEL_CHANGE,
    EventActions.TENANT_DELETION,
    EventActions.LICENSE_DELIVERY_RECEIVED,
    EventActions.CONTRACT_TYPE_CHANGED,
    EventActions.LICENSE_KEY_DELETION,
];

export const REGISTER_ACTIONS: string[] = [EventActions.REGISTER];

export const UNREGISTER_ACTIONS: string[] = [EventActions.UNREGISTER];

export const UNRECOGNISED_ACTIONS: string[] = [EventActions.UNRECOGNISED];

export const BUNDLE_UPDATE_ACTIONS: string[] = [EventActions.BUNDLE_CHANGE];

export const RATE_CARD_UPDATE_ACTIONS: string[] = [EventActions.RATE_CARD_CHANGE];

export const ADD_ACTIONS: string[] = [EventActions.LICENSE_POOL_UPDATE];

export interface LicenseEventExportNotificationData {
    jobUuid: string;
    downloadUrl?: string;
    expirationSeconds?: number;
    error?: string;
}
